import { Chemise } from './chemise';
import { ClassementFardeChemise } from './classement-farde-chemise';

export class Farde {
  accesRestreint: boolean;
  archive: boolean;
  archiveDate: number;
  chemises: Chemise[];
  classement: ClassementFardeChemise;

  classementAffine: string;
  classementId: number;
  description: string;
  id: number;
  localisation: string;
  remarques: string;
  serviceIds: number[];
  serviceProprietaireId: number;
  folderNameAndCode?: string;
}
